<template>
  <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        :disabled="disabled"
        class="card-border"
        v-model="thaiDate"
        label="เลือก"
        append-icon="event"
        readonly
        hide-details
        solo
        flat
        @click:append="openModal"
        :dark="redMode || invert"
        :background-color="redMode ? '#620000' : bgColor ? bgColor : '#ffffff'"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      scrollable
      color="primary"
      @change="saveDate"
      locale="th"
      :min="min"
      :max="max"
      :readonly="readonly"
    >
      <v-spacer></v-spacer>
      <v-btn v-show="!(readonly || disabled || hideclearbtn)" color="primary" @click="clearData"
        >ล้าง</v-btn
      >
    </v-date-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'DatePicker',
  data() {
    return {
      date: '',
      modal: false,
      deDate: ''
    };
  },
  props: {
    defaultDate: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    redMode: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    min: {
      type: String,
      default: undefined
    },
    max: {
      type: String,
      default: undefined
    },
    bgColor: {
      type: String,
      default: undefined
    },
    invert: {
      type: Boolean,
      default: false
    },
    hideclearbtn: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.defaultDate !== '' && this.defaultDate !== undefined && isNaN(this.defaultDate)) {
      this.date = this.defaultDate;
      this.deDate = this.defaultDate;
      this.saveDate();
      this.deDate = '';
    }
  },
  computed: {
    thaiDate() {
      if (
        (this.date === '' || this.date === null) &&
        (this.deDate === null || this.deDate === '')
      ) {
        return '';
      }
      return this.utils.formatToDateThai(this.date || this.deDate);
    }
  },
  methods: {
    saveDate() {
      const d = new Date(this.date);
      this.$refs.dialog.save(this.date);
      this.$emit('input', this.utils.getLocalDate(d));
    },
    setDefaultData(defaultDate) {
      // this.date = this.defaultDate;
      this.date = defaultDate;
      this.saveDate();
      // this.$refs.dialog.save(this.date);
    },
    clearData() {
      this.date = '';
      this.saveDate();
      // this.$refs.dialog.save(this.date);
    },
    openModal() {
      this.modal = true;
    }
  },
  watch: {
    defaultDate(date) {
      this.setDefaultData(date);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
